/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { newPhraseKioskLoaderScreenSchema } from "./newPhraseKioskLoaderScreenSchema.ts";

export const newKioskLoaderScreenSchema = z.object({
	type: z.string(),
	image_link: z.string().nullable(),
	phrase_interval: z.int(),
	phrase: newPhraseKioskLoaderScreenSchema,
});
